module.exports = __webpack_public_path__ + "img/cns_email_ios8.6d2869ab.png";